// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static cerrar_session: string = "cerrar_session";
    public static notificaciones: string = "notificaciones";
    public static table: string = "table";
    public static tablas: string = "tablas";
    public static tablas_test: string = "tablas_test";
    public static usuarios: string = "usuarios";
    public static usuarioslista: string = "usuarioslista";
    public static usuariosformulario: string = "usuariosformulario";
    public static mi_perfil: string = "mi_perfil";
    public static administracion: string = "administracion";
    public static lostpwd: string = "lostpwd";
    public static confirm_new_password: string = "confirm_new_password";
    public static instalacion: string = "instalacion";
    public static rol: string = "rol";
    public static rollista: string = "rollista";
    public static rolformulario: string = "rolformulario";
    public static plataforma: string = "plataforma";
    public static instalacion_plataforma: string = "instalacion_plataforma";
    public static tablasformulario: string = "tablasformulario";
    public static tablaslista: string = "tablaslista";
    public static menu_plataforma: string = "menu_plataforma";
    public static menu_plataforma_lista: string = "menu_plataforma_lista";
    public static menu_plataforma_formulario: string = "menu_plataforma_formulario";
    public static enumeraciones: string = "enumeraciones";
    public static enumeracion: string = "enumeracion";
    public static viewKanban: string = "viewKanban";
    public static kanban: string = "kanban";
    public static tbkn: string = "tbkn";
    public static viewtbkn: string = "viewtbkn";
    public static dxtable: string = "dxtable";
    public static clientesformulario: string = "clientesformulario";
    public static clientes: string = "clientes";
    public static usuarios_plataforma_admin: string = "usuarios_plataforma_admin";
    public static admin: string = "admin";
    public static logs: string = "logs";
    public static logsformulario: string = "logsformulario";
    public static otp: string = "otp";
    public static main: string = "main";
    public static configurarotp: string = "configurarotp";
    public static logearotp: string = "logearotp";
    public static permisos: string = "permisos";
    public static permisoslista: string = "permisoslista";
    public static menu_plataforma_organizar: string = "menu_plataforma_organizar";
    public static dynamic_form_builder: string = "dynamic_form_builder";
    public static form_builder: string = "form_builder";
    public static agents_admin: string = "agents_admin";
    public static form_builder_preview: string = "form_builder_preview";
    public static clientes_ejemplo: string = "clientes_ejemplo";
    public static datos_empresaformulario_empresa: string = "datos_empresaformulario_empresa";
    public static active_users: string = "active_users";
    public static ipRateLimiting: string = "ipRateLimiting";
    public static scheduled_tasks: string = "scheduled_tasks";
    public static centros_admin: string = "centros_admin";
    public static centros_servicios_admin: string = "centros_servicios_admin";
    public static canales_entrada_admin: string = "canales_entrada_admin";
    public static estados_cita_admin: string = "estados_cita_admin";
    public static pacientes_leads_admin: string = "pacientes_leads_admin";
    public static solicitudes_cita_admin: string = "solicitudes_cita_admin";
    public static solicitudes_cita_estado_hist_admin: string = "solicitudes_cita_estado_hist_admin";
    public static solicitudes_eventos_audit_admin: string = "solicitudes_eventos_audit_admin";
    public static public_agenda_test_admin: string = "public_agenda_test_admin";
    public static public_agenda_wizard_test_admin: string = "public_agenda_wizard_test_admin";
    public static citas_dashboard_admin: string = "citas_dashboard_admin";
    public static agenda_calendar_admin: string = "agenda_calendar_admin";
    public static citas_edit_wizard_test_admin: string = "citas_edit_wizard_test_admin";
    public static manychat_logs_admin: string = "manychat_logs_admin";
    public static cache_diagnostics_admin: string = "cache_diagnostics_admin";
    public static public_agenda_requests_log_admin: string = "public_agenda_requests_log_admin";
    public static citas_eliminar_admin: string = "citas_eliminar_admin";
    public static pacientes_gesden_index_admin: string = "pacientes_gesden_index_admin";
}
